import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "@ch/router/HealthDiaryRoutes/enums.ts";
import StressPageLazy from "@ch/pages/StressPage";
import StressHistoryPageLazy from "@ch/pages/StressPage/StressHistoryPageLazy.tsx";
import StressLogPageLazy from "@ch/pages/StressPage/StressLogPageLazy.tsx";
import type { TRouteObject } from "@ch/helpers/utils/types.ts";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import FeatureFlagRouteGate from "@ch/components/Gate/FeatureFlagRouteGate";

export const stressRoutes: TRouteObject[] = [
  {
    path: HealthDiaryPathsEnum.STRESS_HISTORY,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <StressHistoryPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Stress History",
      }),
      crumb: () => ({
        title: "Stress History",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_STRESS_HISTORY,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.STRESS_LOG,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <StressLogPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Stress Log",
      }),
      crumb: () => ({
        title: "Log Stress",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_STRESS_LOG,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.STRESS,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <StressPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Stress",
      }),
      crumb: () => ({
        title: "Stress",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_STRESS,
      }),
    },
  },
];
